

<template>
	<a v-if="optionen.length" class="nav-bubble p-5" :class="[className, {out:out}]" @click="onClick( $event )">
		<div class="bubble p-1 px-3 p-md-2 px-md-5">
			<h5>
				{{ title }}
			</h5>
			<p v-if="selection[optName]">
				{{ selection[optName].title }}
				<template v-if="selection[optName].farbe">
					{{ selection[optName].farbe.title }}
				</template>
			</p>
		</div>
	</a>
</template>

<script>

import { EventBus } from '@/common/eventbus.js'
import { store } from '@/store'
import { mapState } from 'vuex'
import { Log } from '@/services/log.service'
import { Finder } from '@/services/finder.service'

export default {
	store,
	props: ['className', 'title', 'optName', 'selection', 'filters', 'globalFilters'],
	data: () => {
		return {
			out: true
		}
	},
	computed: {
		...mapState('configurator', ['configurator']),
		...mapState('settings', ['presets']),
		optionen () {
			console.log(this.optName);
			var results = Finder.findByCriteria(this.filters, this.optName);
			return results;
		}
	},

	methods: {
		onClick( event ) {
			this.$emit('clicked', {optName:this.optName});
		}
	}

}
</script>

<style scoped lang="scss">
	.nav-bubble {
		position: absolute;
		cursor: pointer;
		transition: 0.4s all cubic-bezier(0.175, 0.885, 0.32, 1.275);
		transform-origin: right bottom;
		transform: translateX(-100%);
		backface-visibility: hidden;
		&:hover {
			opacity: 1;
		}
		&:hover .bubble {
			transform: scale(1.05);
		}
		&.out {
			transition: 0.4s all cubic-bezier(0.175, 0.885, 0.32, 1.275);
			transform: translateX(-100%) scale(0);
			pointer-events: none;
			opacity: 0;
		}
	}

	@for $i from 1 through 8 {
		.nav-bubble {
			&:nth-child(#{$i}) {
				transition-delay: #{$i*100 + 1500}ms;
			}
			&.out:nth-child(#{$i}) {
				transition-delay: #{$i*100}ms;				
			}
		}
	}

	.bubble {
		position: relative;
		background-color: rgba(#fff, 0.5);
		color: #fff;
		user-select: none;
		filter: drop-shadow(0 0 4px rgba(#000, 0.5));
		transition: 0.4s all;
		transform-origin: right 150%;
		&:after {
			content: '';
			position: absolute;
			right: 0;
			bottom: -15px;
			border: 15px solid transparent;
			border-top-color: rgba(#fff, 0.5);
			border-bottom: 0;
			border-right: 0;
			transform-origin: right top;
			transform: skewX(25deg);
		}
	}

	.nav-bubble.top {
		transform-origin: right top;
		.bubble {
			transform-origin: right -50%;
		}
		.bubble:after {
			bottom: auto;
			top: -15px;
			right: -7px;
			transform-origin: left top;
			transform: skewX(-25deg);
			border: 15px solid transparent;
			border-bottom-color: rgba(#fff, 0.5);
			border-top: 0;
			border-right: 0;
		}
	}

	.nav-bubble.right {
		transform-origin: left bottom;
		transform: translateX(0) translateY(-100%);
		.bubble {
			transform-origin: left 150%;
		}
		&:hover .bubble {
			transform: translateX(0) scale(1.05);
		}
		&.out {
			transform: translateX(0) scale(0);
		}
		.bubble:after {
			right: auto;
			left: 0;
			transform-origin: left top;
			transform: skewX(-25deg);
			border-left: 0;
			border-right: 15px solid transparent;
		}
		&.top {
			transform: translateX(0);
			.bubble:after {
				transform: skewX(25deg);
				transform-origin: right bottom;
			}
		}
	}

	h5 {
		line-height: 1.4;
		font-size: 0.8rem;
		margin: 0;
		letter-spacing: 0.08em;
		text-transform: uppercase;
		@media (min-width: 720px) {
			font-size: 1rem;
		}
	}

	p {
		font-size: 0.8rem;
		@media (min-width: 720px) {
			font-size: 1rem;
		}
		margin: 0;
		color: #084c91;
	}
</style>



// WEBPACK FOOTER //
// src/components/NavBubble.vue